import React, { useMemo } from 'react';
import FormSelectStatic from 'modules/transactions/components/FormSelectStatic';
import {
  ReportsProvider,
  useReportsContext,
} from 'partial/wrappers/ReportsContext';
import Button from 'partial/components/Button';
import { downloadArrayToCsv } from 'helper';
import dayjs from 'dayjs';
import FormDatePicker from 'partial/components/form/FormDatePicker';

const typeOptions = [
  { label: 'Cash In', value: 'CASH_IN' },
  { label: 'Sender Name Subscription', value: 'SENDER_NAME_SUBSCRIPTION' },
  { label: 'SMS', value: 'SMS' },
  { label: 'SMS Blast', value: 'SMS_BLAST' },
  { label: 'Airtime Load', value: 'AIRTIMELOAD' },
];

const statusOptions = [
  { label: 'Success', value: 'SUCCESS' },
  { label: 'Pending', value: 'PENDING' },
  { label: 'Draft', value: 'DRAFT' },
  { label: 'Failed', value: 'FAILED' },
];

const options = [
  { label: 'Clients Information', value: 'client-information' },
  { label: 'Mask Name', value: 'mask-name' },
  { label: 'SMS Usage and SMS Consumption', value: 'sms-usage' },
  { label: 'Payment Transactions', value: 'payment-transactions' },
  { label: `Subscriber's Current Balance`, value: 'current-balance' },
  { label: 'Registration Report', value: 'registration-report' },
  { label: 'Wallet Balance', value: 'wallet-balance' },
];

function ReportsContainer() {
  const {
    payload,
    setFilter,
    current,
    setCurrent,
    currentConfig,
    exportData,
    isExporting,
    organizationId,
    setOrganizationId,
    organizationOptions,
    handleOrgSearch,
    walletType,
    setWalletType,
    walletStatus,
    setWalletStatus,
  } = useReportsContext();
  const {
    title,
    exportFileName,
    component: Component,
    withFilter,
    withOrgFilter,
    withTypeFilter,
    withStatusFilter,
  } = currentConfig;

  const fileDate = useMemo(
    () =>
      payload?.date_from && payload?.date_to
        ? `${dayjs(payload?.date_from).format('YYYY-MM-DD')}-${dayjs(
            payload?.date_to,
          ).format('YYYY-MM-DD')}`
        : dayjs().format('YYYY-MM-DD'),
    [payload],
  );

  const fileName = `${exportFileName}_${fileDate}`;

  const handleExport = () => {
    downloadArrayToCsv(exportData, fileName);
  };

  return (
    <section className="p-6 bg-white drop-shadow rounded-lg h-full flex flex-col gap-5">
      <div className="flex items-center justify-between space-x-5">
        <div className="flex items-center gap-4">
          <FormSelectStatic
            name="type"
            data={options}
            value={current?.type}
            onChange={setCurrent}
            withClear={false}
          />
          {withFilter && (
            <FormDatePicker
              key={title}
              onChange={setFilter}
              defaultValue={dayjs().format('YYYY-MM-DD')}
            />
          )}
          {withOrgFilter && (
            <FormSelectStatic
              name="organization"
              data={organizationOptions}
              value={
                organizationOptions.find((o) => o.value === organizationId) || {
                  label: '',
                  value: '',
                }
              }
              callBack={setOrganizationId}
              onQueryChange={handleOrgSearch}
              placeholder="All Organizations"
              readOnly={false}
              withClear
            />
          )}
          {withTypeFilter && (
            <FormSelectStatic
              name="type"
              data={typeOptions}
              value={
                typeOptions.find((o) => o.value === walletType) || {
                  label: '',
                  value: '',
                }
              }
              callBack={setWalletType}
              placeholder="All Types"
              withClear
            />
          )}
          {withStatusFilter && (
            <FormSelectStatic
              name="status"
              data={statusOptions}
              value={
                statusOptions.find((o) => o.value === walletStatus) || {
                  label: '',
                  value: '',
                }
              }
              callBack={setWalletStatus}
              placeholder="All Statuses"
              withClear
            />
          )}
        </div>

        <Button
          className="!px-8"
          primary
          onClick={handleExport}
          disabled={isExporting}
        >
          EXPORT
        </Button>
      </div>
      <div className="flex-1 min-h-[65vh] flex flex-col">
        <div className="rounded-sm bg-primary text-white font-bold py-1 px-4">
          {title}
        </div>
        <div className="flex-1">
          <Component />
        </div>
      </div>
    </section>
  );
}

function Reports() {
  return (
    <ReportsProvider>
      <ReportsContainer />
    </ReportsProvider>
  );
}

export default Reports;
